import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationDetoxificationPhase2Combined from "./index";

const MethylationDetoxificationPhase2WithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationDetoxificationPhase2Combined}
    keyControlsId="methylation-detoxification-phase2-key"
    {...props}
  />
);

export default MethylationDetoxificationPhase2WithToggleKey;
